import { cx } from './util';

// §2.6 Avatar: initials on a 4px square. No photos, no circles. size: sm 20 · md 24 · lg 32.
export default function Avatar({ initials, name, size = 'sm' }) {
  const text = (initials || (name || '').split(/\s+/).map(w => w[0]).join('').slice(0, 2) || '?').toUpperCase();
  return <span className={cx('ui ui-avatar', size !== 'sm' && `ui-avatar--${size}`)} title={name} aria-label={name}>{text}</span>;
}

export function AvatarStack({ people = [], max = 3 }) {
  const shown = people.slice(0, max);
  return (
    <span className="ui ui-avatars" title={people.map(p => p.name).join(', ')}>
      {shown.map(p => <Avatar key={p.name} name={p.name} initials={p.initials} />)}
      {people.length > max && <span className="ui-meta">+{people.length - max}</span>}
    </span>
  );
}
